import { useState, useEffect, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { RxHamburgerMenu } from "react-icons/rx";
import { IoIosCloseCircle } from "react-icons/io";
import { SlArrowDown, SlArrowUp } from "react-icons/sl";

import logo from "@/assets/icons/maqrah.png";
import Button from "./Button";
import {
  academyPath,
  landingPath,
  aboutPath,
  contactPath,
  studentPath,
  blogPath,
} from "../routes/path";
import { socialLinks } from "../Data/data";
import { AcademyContext } from "../../views/Academy/AcademyContextDefinition";

const Nav = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [activeLink, setActiveLink] = useState("/");

  const location = useLocation();
  const context = useContext(AcademyContext);
  const { isDropdownOpen } = context || {};
  const navLinks = [
    { text: "Home", path: landingPath },
    {
      text: "Academy",
      path: academyPath,
      hasDropdown: true,
      dropdownContent: () =>
        isDropdownOpen && (
          <div className="absolute mt-2 bg-white shadow-lg rounded-md p-4 w-48">
            <ul className="space-y-2">
              <li>
                <Link to="#" className="block hover:text-blue-400">
                  Courses
                </Link>
              </li>
              <li>
                <Link to="#" className="block hover:text-blue-400">
                  Instructors
                </Link>
              </li>
              <li>
                <Link to="#" className="block hover:text-blue-400">
                  Schedule
                </Link>
              </li>
            </ul>
          </div>
        ),
    },
    { text: "About Us", path: aboutPath },
    { text: "Contact", path: contactPath },
    { text: "Students Profile", path: studentPath },
    { text: "Blog", path: blogPath },
  ];
  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location.pathname]);

  const handleToggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleToggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  return (
    <nav className="shadow-lg fixed top-0 left-0 right-0 w-full z-50  ">
      <div className="px-4 py-3 sm:p-4 bg-white flex justify-between items-center">
        <div className="sm:px-10">
          <Link
            to={landingPath}
            aria-label="Go to homepage"
            onClick={() => {
              setActiveLink(landingPath);
            }}
          >
            <img width={45} src={logo} alt="Company Logo" className="sm:w-24" />
          </Link>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden sm:block sm:w-full">
          <div className="flex justify-between items-center">
            <ul className="flex items-center gap-10 font-semibold text-[#004C97]">
              {navLinks.map((link, index) => (
                <li key={index}>
                  {link.hasDropdown ? (
                    <div className="relative">
                      <div
                        className={`flex items-center cursor-pointer ${
                          activeLink.includes(link.path)
                            ? "text-[#BCC6CC]"
                            : "hover:text-[#BCC6CC]"
                        }`}
                        onClick={handleToggleDropdown}
                      >
                        <span>{link.text}</span>
                        {showDropdown ? (
                          <SlArrowUp className="ml-1 text-xs" />
                        ) : (
                          <SlArrowDown className="ml-1 text-xs" />
                        )}
                      </div>
                      {showDropdown && (
                        <div className="absolute mt-2 bg-white shadow-lg rounded-md p-4 w-48 z-10">
                          <ul className="space-y-2">
                            {link.dropdownItems.map((item, idx) => (
                              <li key={idx}>
                                <Link
                                  to={item.path}
                                  className="block hover:text-blue-400 py-1"
                                  onClick={() => {
                                    setActiveLink(item.path);
                                  }}
                                >
                                  {item.text}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  ) : (
                    <Link
                      to={link.path}
                      className={
                        activeLink === link.path
                          ? "text-[#BCC6CC]"
                          : "hover:text-[#BCC6CC]"
                      }
                      onClick={() => {
                        setActiveLink(link.path);
                      }}
                    >
                      {link.text}
                    </Link>
                  )}
                </li>
              ))}
              <li>
                <div className="flex gap-5 text-xl justify-center">
                  {socialLinks.map((social, index) => (
                    <a
                      key={index}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={social.label}
                    >
                      {social.icon}
                    </a>
                  ))}
                </div>
              </li>
            </ul>
            <Link
              to={academyPath}
              onClick={() => {
                setActiveLink(academyPath);
              }}
            >
              <Button
                btnBgColor="bg-[#004C97] hover:bg-white hover:text-[#3b76db]"
                btnColor="text-white"
                btnText="Visit Academy"
                padding="py-3 px-6"
              />
            </Link>
          </div>
        </div>

        {/* Mobile Menu Button */}
        <button
          id="mobile-menu-button"
          onClick={handleToggleMobileMenu}
          className="sm:hidden text-[#66B2FF] p-2"
          aria-label={showMobileMenu ? "Close menu" : "Open menu"}
          aria-expanded={showMobileMenu}
        >
          {showMobileMenu ? (
            <IoIosCloseCircle className="text-4xl" />
          ) : (
            <RxHamburgerMenu className="text-4xl" />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {showMobileMenu && (
        <div className="sm:hidden w-full bg-white absolute left-0 right-0 top-full p-4 shadow-md z-50">
          <ul className="grid gap-6 font-semibold text-[#004C97] mb-4">
            {navLinks.map((link, index) => (
              <li key={index} className="py-2">
                {link.hasDropdown ? (
                  <div>
                    <div
                      className={`flex items-center cursor-pointer ${
                        activeLink.includes(link.path)
                          ? "text-[#BCC6CC]"
                          : "hover:text-[#BCC6CC]"
                      }`}
                      onClick={handleToggleDropdown}
                    >
                      <span>{link.text}</span>
                      {showDropdown ? (
                        <SlArrowUp className="ml-1 text-xs" />
                      ) : (
                        <SlArrowDown className="ml-1 text-xs" />
                      )}
                    </div>
                    {showDropdown && (
                      <div className="mt-2 pl-4">
                        <ul className="space-y-2">
                          {link.dropdownItems.map((item, idx) => (
                            <li key={idx}>
                              <Link
                                to={item.path}
                                className="block hover:text-blue-400 py-1"
                                onClick={() => {
                                  setActiveLink(item.path);
                                }}
                              >
                                {item.text}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                ) : (
                  <Link
                    to={link.path}
                    className={
                      activeLink === link.path
                        ? "text-[#BCC6CC]"
                        : "hover:text-[#BCC6CC]"
                    }
                    onClick={() => {
                      setActiveLink(link.path);
                    }}
                  >
                    {link.text}
                  </Link>
                )}
              </li>
            ))}
            <li>
              <div className="flex gap-5 text-2xl justify-center">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.label}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </li>
          </ul>
          <div className="text-center">
            <Link
              to={academyPath}
              onClick={() => {
                setActiveLink(academyPath);
              }}
            >
              <Button
                btnBgColor="bg-[#004C97] hover:bg-white hover:text-[#3b76db] shadow-xl"
                btnColor="text-white"
                btnText="Visit Academy"
                padding="py-3 px-6"
              />
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Nav;
